import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { forwardRef } from 'react';
// import AiSummaryIcon from '../../assets/webImages/Icon-Summary.svg';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ChapterSummerizeList from './ChapterSummerizeList';
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ChapterSummerize({ book_id, slug, is_header, is_clone, open, setOpen, is_header_two = false }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#0066cc',
          borderRadius: '50%',
          width: '4rem',
          height: '4rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          zIndex: '2',
        }}
        onClick={() => setOpen((state) => !state)}
      >
        {/* <img src={AiSummaryIcon} width="45px" height="45px" alt="Summaries" /> */}
        <SummarizeIcon sx={{ fontSize: 37, color: 'white' }}/>
      </Box>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Summaries
            </Typography>
          </Toolbar>
        </AppBar>
        <ChapterSummerizeList
          book_id={book_id}
          is_clone={is_clone}
          is_header={is_header}
          slug={slug}
          is_header_two={is_header_two}
        />
      </Dialog>
    </>
  );
}
